/*
 * @Author: kian
 * @Date: 2021-11-11 08:56:44
 * @LastEditors: kian
 * @LastEditTime: 2021-11-24 17:38:53
 * @Description:
 */
import Vue from 'vue';
import { LiveStatusMap } from '@/constants/index';
export function rafThrottle(fn) {
  let locked = false;
  return function (...args) {
    if (locked) return;
    locked = true;
    window.requestAnimationFrame(_ => {
      fn.apply(this, args);
      locked = false;
    });
  };
}

export const isFirefox = function () {
  return (
    !Vue.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i)
  );
};

/**
 * @description 获取路由传参
 * @param { string } url 路由参数
 */
export const getUrlQuery = url => {
  const queryStr = url.split('?')[1];
  if (queryStr) {
    const query = {};
    const queryArr = queryStr.split('&');
    if (queryArr.length > 0) {
      queryArr.forEach(item => {
        const prop = item.split('=');
        if (prop.length > 1) {
          query[prop[0]] = prop[1];
        }
      });
    }
    return query;
  }
  return null;
};

/**
 * @description 对数字做千位分隔
 * @param { number } num 处理数字
 * @returns { string } 格式化后的数字
 */
export const numFormat = num => {
  const res = num.toString().replace(/\d+/, n => {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => {
      return `${$1},`;
    });
  });
  return res;
};

/**
 * @description 股票格式化
 * @param { string } stock 股票代码
 */
export const stockInit = stock => {
  if (stock.length < 3) return null;
  return {
    market: stock.slice(0, 2).toLowerCase(),
    code: stock.slice(2),
  };
};

/**
 * @description 跳转链接
 * @param { String } url 跳转路径
 * @param { String } type 跳转类型 href: 直跳 _blank: 新开页
 */
export const linkPage = (url, type = '_blank') => {
  if (!url) return;

  // 加上 location.origin 是因为某些 url 不带域名
  const uuu = new URL(url, location.origin);
  // 如果当前地址和目标地址一致 就不跳转
  if (
    `${uuu.pathname}${uuu.search}` ===
    `${window.location.pathname}${window.location.search}`
  ) {
    // eslint-disable-next-line no-console
    console.log('目标地址和当前地址一致 不跳转');
    return;
  }
  // 如果这两个路径直接打开
  if (
    uuu.origin.includes('m.gelonghui.com') &&
    [
      '/mobile',
      '/thanksgiving',
      '/certification/realname',
      '/certification/real-name',
    ].some(i => uuu.pathname.includes(i))
  ) {
    openLink(url, type);
    return;
  }
  // 内部的地址(非静态域名)直接去除域名打开
  if (
    uuu.host.includes('gelonghui.com') &&
    !uuu.host.includes('cdn') &&
    !uuu.host.includes('img')
  ) {
    const to = formartRoute(url);
    openLink(to, type);
    return;
  }
  // 别的外部地址不处理直接打开
  openLink(url, type);
};

/**
 * @description 跳转链接方式
 * @param { String } url 跳转路径
 * @param { String } type 跳转类型 href: 直跳 _blank: 新开页
 */
export const openLink = (url, type = '_blank') => {
  if (type === '_blank') {
    window.open(url);
  } else if (type === 'href') {
    location.href = url;
  }
};

/**
 * @description 路由去除域名
 * @param { String } url 原路由
 * @returns { String } 格式化路由
 */
export const formartRoute = url => {
  return url?.replace(/^http[s]{0,1}:\/\/[^/]+/, '');
};

export const colorRgb = function (color, opacity = 1) {
  let sColor = color.toLowerCase();
  // 十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = '#';
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    // 处理六位的颜色值
    const sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
    }
    return 'rgba(' + sColorChange.join(',') + ',' + opacity + ')';
  }
  return sColor;
};

export const GetLiveStatusInfo = status => {
  if (!status || status < 0) return LiveStatusMap[-1];
  if (status > 3) {
    status = 4;
  }
  return LiveStatusMap[status];
};

/**
 * @description 替换中间的字符串
 * @param { string } str 待处理字符串
 * @param { number } startRetain 展示前字符数
 * @param { number } endRetain 展示后字符数
 * @param { string } subString 替换字符
 */
export const replaceToHidden = (
  str,
  startRetain = 3,
  endRetain = 4,
  subString = '*'
) => {
  if (
    !str ||
    typeof str !== 'string' ||
    typeof startRetain !== 'number' ||
    typeof endRetain !== 'number' ||
    typeof subString !== 'string'
  ) {
    console.error('请检查传入参数是否正确');
    return '';
  }
  const reg = new RegExp(`(?<=.{${startRetain}}).{1}(?=.{${endRetain}})`, 'g');
  return str.replace(reg, subString);
};

/**
 * @description 引用脚本
 * @param { string } path 路径
 * @param { function } success  成功回调
 */
export const importScript = (path, success) => {
  const oS = document.createElement('script');
  oS.src = path;
  document.getElementsByTagName('head')[0].appendChild(oS);
  oS.onload = () => {
    success && success();
  };
};
